import React from "react";
import { agencyService } from "@/services/agency.service";
import { AgencyBlogResponseDto } from "@/services/admin/agencyBlog.admin.service";
import { RichTextPreview } from "../Editor/RichTextPreview";
import { useParams } from "react-router-dom";
import { TextGenerateEffect } from "../ui/text-generate-effect";


const AgencyBlogDetails = () => {
  const [post, setPost] = React.useState<AgencyBlogResponseDto | null>(null);
  const { id } = useParams<{ id: string }>();

  React.useEffect(() => {
    const fetchPost = async () => {
      if (!id) return;
      const post = await agencyService.getAgencyBlogById(id);
      setPost(post);
    };
    fetchPost();
  }, []);
  return (
    <div className="container mx-auto max-w-4xl px-4 md:px-0">
      <TextGenerateEffect className="text-3xl space-y-6" filter words={post?.title??""} />
      <RichTextPreview content={post?.description??""} />
    </div>
  );
};

export { AgencyBlogDetails };
